import { API_BASE_URL } from "@/config";
import { BaseService } from "@/services/base-service";

/**
 * Fetches the CSRF token required by write operations (e.g. order creation).
 * Extends BaseService to ensure the request goes through Midway authentication.
 */
export class CsrfService extends BaseService {
  constructor() {
    super(API_BASE_URL);
  }

  public async getToken(): Promise<string> {
    const response = await this.fetch("/csrf");
    if (!response.ok) {
      throw new Error(`Failed to fetch CSRF token: ${response.status}`);
    }
    const json = await response.json();
    return json.token as string;
  }
}
